module.exports = __webpack_public_path__ + "prod/1.42.2/img/yycj_one.92bf6643.png";